import type { NextPage } from 'next'


interface IProps {
  prefix?: string;
  className?: string;
}

const Component: NextPage<IProps> = ({ children, prefix, className }) => {
  return (
    <h2 className={`${className && className} text-[24px] font-medium tracking-tighter`}>
      {prefix && (
        <span className='text-gg-blue'>
          {prefix}
        </span>
      )}
      <span className={`${prefix && 'pl-2'}`}>
        {children}
      </span>
    </h2>
  )
}

export default Component
